const initState = {
  ads: [],
  allCategories: [],
  lastDocument: null,
  hasMoreDocument: true,
};

const adsReducers = (state = initState, action) => {
  switch (action.type) {
    case "GET_ADS":
      return {
        ...state,
        ads: action.payload.ads,
        lastDocument: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    case "GET_ADS_CATEGORIES":
      return {
        ...state,
        allCategories: action.payload.categories,
      };
    case "GET_ADS_LOAD_MORE":
      return {
        ...state,
        ads: [...state.ads, ...action.payload.ads],
        lastDocument: action.payload.lastVisible,
        hasMoreDocument: action.payload.hasMoreDocument,
      };
    default:
      return {
        ...state,
      };
  }
};
export default adsReducers;
